const displayProfessionDetail = () => {
    let selectedProfession = $('#select-profession');
    let hideStatus = selectedProfession.val() !== 'other';

    $('#profession_detail').attr('hidden', hideStatus);
    $('#text-profession-detail').attr('required', !hideStatus);
}

export function professionSelector ()
{
    let initialProfessionSector = $('#select-profession-sector option:selected').val()

    if (initialProfessionSector) {
        $('[data-profession-sector]').attr('hidden', true);
        $('[data-profession-sector="'+initialProfessionSector+'"]').attr('hidden', false);
    }

    displayProfessionDetail()

    $('#select-profession-sector').change((event) => {
        let clickedProfessionTitle = $(event.target).find('option:selected').val();
        $('[data-profession-sector]').attr('hidden', true);
        $('#select-profession').val('');
        $('[data-profession-sector="'+clickedProfessionTitle+'"]').attr('hidden', false);
        displayProfessionDetail();
    });

    $('#select-profession').change(() => {
        displayProfessionDetail();
    });
}